import { useQuery } from "react-query";

import { useCombinationRules } from "./useCombinationRules";
import { COMBINATION_RULES_QUERY_KEY } from "./useGetCombinationRules";

export const useGetRuleFilterDealers = () => {
  const { filterDealersGet } = useCombinationRules();

  const { data, isLoading, isError } = useQuery({
    queryKey: [COMBINATION_RULES_QUERY_KEY, "filterDealers"],
    queryFn: () => filterDealersGet(),
  });

  return {
    dealers: data?.data,
    isLoading,
    isError,
  };
};
